import { Routes } from '@angular/router';
import { NotFoundComponent } from './packages-angular/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app-name',
  },
  {
    path: 'modules',
    loadChildren: () =>
      import('./modules/modules.module').then(m => m.ModulesModule),
  },
  {
    path: 'modules/:code/auth/:refreshToken/:authCompany/:license/:module/:submodule/:establishmentId',
    loadChildren: () =>
      import('./modules/modules.module').then(m => m.ModulesModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
